export const FEED_SNAP_INDEX_KEY_FOR_YOU = "feed-snap-index-for-you";
export const FEED_SNAP_INDEX_KEY_FOLLOWING = "feed-snap-index-following";
